import { API_BASE } from "helpers/api_config";
import { gorselYuklemeParametreleri } from "helpers/gorselKucult";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  Badge,
  Button,
} from "reactstrap";
import * as Yup from "yup";
import {
  requiredText,
} from "helpers/validators";
import { useFormik } from "formik";
import { NameSurname } from "./contactlistCol";


//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import * as moment from "moment";
import axios from 'axios';
import jsPDF from "jspdf";
import "jspdf-autotable";



import {
  getNews_Comment as onGetNews_Comment,
  addNews_Category as onAddNews_Category,
  updateNews_Comment as onUpdateNewsComment,
  deleteNews_Comment as onDeleteNews_Comment,
} from "store/contacts/actions";
import { isEmpty } from "lodash";


//redux
import { useSelector, useDispatch } from "react-redux";

import SayfaRehberi from "../../../components/Common/SayfaRehberi";
const ContactsList = props => {

  //meta title
  document.title = "Aktüel Yorumlar | BERLİN ESNAF ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getFileName, setFileName] = useState('');

  
  const [getHtmlDataLong, setHtmlDataLong] = useState();
   
  const [getFileSubMedia, setFileSubMedia] = useState([]);

  const [getSubMediaID, setSubMediaID] = useState();

  const [getFileSubMediaAdd, setFileSubMediaAdd] = useState([]);

  // validation

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      title: (contactEdit && contactEdit.News_Comment_Text) || "",

   
 

    },
    validationSchema: Yup.object({
      title: requiredText("Yorum metni", { min: 1, max: 2000 }),
    }),
    onSubmit: values => {
      if (isEdit) {

        const updateUser = {
          ID: contactEdit.ID,
          News_Comment_Text: values.title,

        };
        dispatch(onUpdateNewsComment(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
          News_Comment_Text: values["title"],
        };
        // save new user
        dispatch(onAddNews_Category(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.newscomment,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);

  const [isEdit, setIsEdit] = useState(false);

  // Detay modali: satira (ya da goz simgesine) tiklayinca yorumun tamami,
  // hangi aktuel habere yazildigi ve kimin yazdigi tek ekranda gorunur.
  // Listede metin kirpildigi icin uzun yorumlar ancak burada okunabiliyor.
  const [detayModal, setDetayModal] = useState(false);
  const [detay, setDetay] = useState(null);

  const detayAc = (satir) => {
    setDetay(satir);
    setDetayModal(true);
  };
  const detayKapat = () => setDetayModal(false);

  // Yorum onaylama/reddetme. Mobil uygulamada yorumlar IsActive:false olarak
  // kaydedilir; onaylanana kadar yalnizca yazari gorur.
  const onayDegistir = (satir, aktif) => {
    dispatch(onUpdateNewsComment({ ID: satir.ID, IsActive: aktif }));
    setDetay({ ...satir, IsActive: aktif });
  };





  const [getCategory, setCategory] = useState([]);


const handleUserClick = (arg) => {
    const user = arg;

    setEditContact(user);


    setIsEdit(true);


    toggle();
  };


  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
      {
        Header: "Aktüel Başlık",
        accessor: "News.News_Title",
        filterable: true,
        Cell: cellProps => (
          <Link
            to="#"
            className="text-body fw-medium"
            onClick={() => detayAc(cellProps.row.original)}
          >
            {cellProps.value || <span className="text-muted">(haber silinmiş)</span>}
          </Link>
        ),
      },

      {
        Header: "Aktüel Yorum",
        accessor: "News_Comment_Text",
        filterable: true,
        // Yorumlar cok uzun olabiliyor; listede kirpiyoruz, tamami detayda.
        Cell: cellProps => {
          const metin = cellProps.value || "";
          const kisa = metin.length > 90 ? metin.slice(0, 90) + "…" : metin;
          return (
            <Link
              to="#"
              className="text-body"
              onClick={() => detayAc(cellProps.row.original)}
            >
              {kisa}
            </Link>
          );
        },
      },

      {
        Header: "Kullanıcı Adı",
        accessor: "Users.Users_Name_Surname",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Tarih",
        accessor: "News_Comment_Created_DateTime",
        filterable: true,
        Cell: cellProps =>
          cellProps.value ? moment(cellProps.value).format("DD.MM.YYYY HH:mm") : "",
      },

      {
        Header: "Durum",
        accessor: "IsActive",
        filterable: true,
        Cell: cellProps => (
          <Badge className={"font-size-12 badge-soft-" + (cellProps.value ? "success" : "warning")}>
            {cellProps.value ? "Onaylı" : "Onay bekliyor"}
          </Badge>
        ),
      },

      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">

              <Link
                to="#"
                className="text-primary"
                onClick={() => detayAc(cellProps.row.original)}
              >
                <i className="mdi mdi-eye-outline font-size-18" id="detailtooltip" />
                <UncontrolledTooltip placement="top" target="detailtooltip">
                  Detay
                </UncontrolledTooltip>
              </Link>

          <Link
                        to="#"
                        className="text-success"
                        onClick={() => {
                          const userData = cellProps.row.original;
                          handleUserClick(userData);
                        }}
                      >
                        <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                        <UncontrolledTooltip placement="top" target="edittooltip">
                          Düzenle
                        </UncontrolledTooltip>
                      </Link>
          
              <Link
                to="#"
                className="text-danger"
                onClick={() => {
                  const userData = cellProps.row.original;
                  onClickDelete(userData);
                }}
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Sil
                </UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );

  // NOT: burada başka bir projeden (Luxun/MSE/Kupon) kalma `_getAuthData`
  // vardı; ölü :9093 portuna istek atıyor, sonucu (`getCategory`) hiçbir yerde
  // gösterilmiyordu. Her sayfa açılışında yakalanmamış hata üretiyordu — kaldırıldı.

  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetNews_Comment());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  const toggle = () => {
    setModal(!modal);
  };

  const toggleMedia = () => {
    setModalMedia(!modalMedia);
  };


  const handleUserClickMedia = (arg) => {
    const user = arg;

    setSubMediaID(user.ID)

    setFileSubMedia(user.EducationSubItem_Media)

    toggleMedia();
  };



  

  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };
  // NOT: burada `setContact(<liste>)` çağıran iki useEffect vardı.
  // `contact` SEÇİLİ SATIRI tutuyor; liste her değiştiğinde tüm dizi ile
  // eziliyor, dizide `.ID` olmadığı için silme sessizce hiçbir şey yapmıyordu.

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteNews_Comment(contact.ID));
    }
    setContact(undefined);
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };



  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }



  // Gorseller yuklenmeden once kucultulur (bkz. helpers/gorselKucult.js)
  const getUploadParams = gorselYuklemeParametreleri

  const handleChangeStatusBanner = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response)
          console.log("lnslkdf", result.file)
          setFileSubMediaAdd(oldArray => [{ fileName: result.file.filename, fileType: result.file.mimetype }, ...oldArray]);
        }
      }
    }
  }
  const handleChangeStatus = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileName(result.file.filename)

        }
      }
    }
  }



  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Aktüel Yorumları Listesi" />
          <SayfaRehberi sayfa="newscomment" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>


                  <TableContainer
                    columns={columns}
                    data={users}
                    isGlobalFilter={true}
                    isAddAktuelCat={false}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />

          
                  {/* YORUM DETAYI
                      Listede yorum metni kirpiliyor ve haber basligi tek satira
                      sigmayabiliyor; tam icerik, yazan kullanici ve onay islemi
                      burada. */}
                  <Modal isOpen={detayModal} toggle={detayKapat} size="lg">
                    <ModalHeader toggle={detayKapat} tag="h4">
                      Yorum Detayı
                    </ModalHeader>
                    <ModalBody>
                      {detay && (
                        <>
                          <Row className="mb-3">
                            <Col sm={4}>
                              <Label className="form-label text-muted mb-0">Aktüel Başlık</Label>
                            </Col>
                            <Col sm={8}>
                              <div className="fw-medium">
                                {(detay.News && detay.News.News_Title) || (
                                  <span className="text-muted">
                                    (bağlı haber bulunamadı — silinmiş olabilir)
                                  </span>
                                )}
                              </div>
                              {detay.News_ID ? (
                                <small className="text-muted">Haber ID: {detay.News_ID}</small>
                              ) : null}
                            </Col>
                          </Row>

                          <Row className="mb-3">
                            <Col sm={4}>
                              <Label className="form-label text-muted mb-0">Kullanıcı</Label>
                            </Col>
                            <Col sm={8}>
                              <div className="fw-medium">
                                {(detay.Users && detay.Users.Users_Name_Surname) || (
                                  <span className="text-muted">(kullanıcı bulunamadı)</span>
                                )}
                              </div>
                              {detay.Users && detay.Users.Users_MailAddress ? (
                                <small className="text-muted d-block">
                                  {detay.Users.Users_MailAddress}
                                </small>
                              ) : null}
                              {detay.News_Comment_NickName ? (
                                <small className="text-muted d-block">
                                  Takma ad: {detay.News_Comment_NickName}
                                </small>
                              ) : null}
                            </Col>
                          </Row>

                          <Row className="mb-3">
                            <Col sm={4}>
                              <Label className="form-label text-muted mb-0">Tarih</Label>
                            </Col>
                            <Col sm={8}>
                              {detay.News_Comment_Created_DateTime
                                ? moment(detay.News_Comment_Created_DateTime).format(
                                    "DD.MM.YYYY HH:mm"
                                  )
                                : "-"}
                            </Col>
                          </Row>

                          <Row className="mb-3">
                            <Col sm={4}>
                              <Label className="form-label text-muted mb-0">Durum</Label>
                            </Col>
                            <Col sm={8}>
                              <Badge
                                className={
                                  "font-size-12 badge-soft-" +
                                  (detay.IsActive ? "success" : "warning")
                                }
                              >
                                {detay.IsActive ? "Onaylı" : "Onay bekliyor"}
                              </Badge>
                            </Col>
                          </Row>

                          <Row className="mb-3">
                            <Col sm={12}>
                              <Label className="form-label text-muted">Yorum</Label>
                              <div
                                className="border rounded p-3 bg-light"
                                style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                              >
                                {detay.News_Comment_Text}
                              </div>
                            </Col>
                          </Row>

                          <Row>
                            <Col className="text-end">
                              {detay.IsActive ? (
                                <Button
                                  color="warning"
                                  className="me-2"
                                  onClick={() => onayDegistir(detay, false)}
                                >
                                  Onayı Kaldır
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  className="me-2"
                                  onClick={() => onayDegistir(detay, true)}
                                >
                                  Onayla
                                </Button>
                              )}
                              <Button color="secondary" onClick={detayKapat}>
                                Kapat
                              </Button>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Düzenle" : "Blog Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>

                
                            <div className="mb-3">
                              <Label className="form-label">Başlık</Label>
                              <Input
                                name="title"
                                label="title"
                                type="text"
                                placeholder="Kategori Başlığını Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>

                           
                         

                          </Col>
                        </Row>
                        <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
